import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { HomeIcon, bagIcon, lockIcon } from "../../assets/uppoIcons/icons";
import { AuthContext } from "../auth/context/Context";
import { ShoppingBagOutlined, ShoppingBagRounded } from "@mui/icons-material";

interface SidebarProps {
  logo?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ logo }) => {
  const { hasRole, user } = useContext(AuthContext);
  const { slug } = useParams<{ slug: string }>();
  const menuItems = [
    {
      text: hasRole("vendorUser") ? "Parcerias" : "Parceiros",
      icon: hasRole("vendorUser") ? bagIcon : HomeIcon,
      path: hasRole("vendorUser") ? `/${slug}/${user?.vendor_id}/benefits` : `/${slug}/vendors`,
    },
    // { text: "Settings", icon: <Settings />, path: "/settings" },
    // { text: "About", icon: <Info />, path: "/about" },
  ];

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: "280px",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "280px",
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <img
            src={logo}
            alt="Logo"
            style={{ maxWidth: "100%", height: "auto", margin: "20px 0px" }}
          />
        </Box>
      </Toolbar>
      {/* <Divider /> */}
      <List sx={{ borderTop: "1px solid #D9D9D9" }}>
        {menuItems.map((item, index) => (
          <ListItem button key={index} component={Link} to={item.path}>
            <ListItemIcon sx={{ minWidth: "45px" }}>{item.icon}</ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontSize: "20px", fontWeight: 700 }}
                >
                  {item.text}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
